import { createSelector } from '@ngrx/store';
import { getCitation } from './get.citations';
import { CommonConstants } from '../../../../shared/common.constant';
import find from 'lodash/find';
import includes from 'lodash/includes';

/*
 * Returns true if the created reference is marked as suggestion
 */
export const getCreatedReferenceIsMarked = createSelector(
  getCitation,
  ({ references, unnumbered_references, createdReferenceId }): boolean =>
    includes(
      (
        find(references, (ref) => ref.citationId === createdReferenceId) ||
        find(
          unnumbered_references,
          (ref) => ref.citationId === createdReferenceId
        )
      )?.citationString,
      CommonConstants.suggestionStart
    )
);
